import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

import './Carousel.css'
 
// class DemoCarousel extends Component {
//     render() {
//         var CarouselImageList = []

    
//         console.log(this.props)
//         return (
//             <Carousel>
                
//                 <div>
//                     <img className='Image' src={this.props.PicArray[2]} />
//                     {/* <p className="legend">Legend 3</p> */}
//                 </div>
//             </Carousel>
//         );
//     }
// };

const DemoCarousel = props => {

    var PicList = [];
    for (let i = 0; i < props.PicArray.length; i++){
        PicList.push(
            <div>
                <img className='Image' src={props.PicArray[i]} />
            </div>
        )
    }

    return (
        <Carousel>
            {PicList}
        </Carousel>
    )
}

export default DemoCarousel
 
// ReactDOM.render(<DemoCarousel />, document.querySelector('.demo-carousel'));
 
// Don't forget to include the css in your page
 
// Using webpack or parcel with a style loader
// import styles from 'react-responsive-carousel/lib/styles/carousel.min.css';
 
// Using html tag:
// <link rel="stylesheet" href="<NODE_MODULES_FOLDER>/react-responsive-carousel/lib/styles/carousel.min.css"/>